(function($){
    Drupal.behaviors.or16 = {
        attach() {

            var componentClass = '.OR16';
            var carouselClass = '.OR16__carousel';

            var $carousel = $(carouselClass);

            function getComponentInstance(context) {
                return $(context).closest(componentClass);
            }

            $carousel.each(function() {
                var $component = getComponentInstance(this);
                // Check if slick is not initialized earlier on same element.
                $(this).not('.slick-initialized').slick({
                    centerMode: true,
                    dots: true,
                    arrows: true,
                    dotsClass: 'OR16__indicators unstyled',
                    prevArrow: '<button class="OR16__button OR16__button--previous"><span class="accessible-hide">Previous slide</span></button>',
                    nextArrow: '<button class="OR16__button OR16__button--next"><span class="accessible-hide">Next slide</span></button>',
                    appendDots: $component.find('.OR16__indicator-container'),
                    appendArrows: $component.find('.OR16__controls-container'),
                    responsive: [
                        {
                            breakpoint: 834,
                            settings: {
                                centerMode: false,
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            });

            var $slideWrapper = $('.slick-track', $carousel);
            $slideWrapper.attr('role', 'presentation');
        }
    };
})(jQuery);
